class User {
  constructor() {
    this.loaded = false;
    this.tokenrefreshinterval = null;
    this.keycloak = null;
    this.defaultuserinfos = {
      loggedin:false,
      type:null,
      email:null,
      name:null,
      given_name:null,
      family_name:null,
      advantage_number:null,
      abo_date_start:null,
      abo_date_end:null,
      htmlloggin:'<a href="#" data-google-interstitial="false" class="login-link autofill-account-link nav-link  nav-button link-keycloak" data-location="header" data-type="connexion" data-target="'+window.location.origin+'/compte/loginsuccess"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"/></svg><span>Se connecter</span></a>',
      htmllogginaccount:'<a href="#" data-google-interstitial="false" class="login-link autofill-account-link nav-link  nav-button link-keycloak" data-location="header" data-type="connexion" data-target="'+window.location.origin+'/compte/loginsuccess"><svg aria-label="mon compte" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svgicon" height="24px" height="24px" fill="#000"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/></svg></a>',
      htmlmenu: '',
      url_espace_pro: null,
    };
    this.userinfos = this.defaultuserinfos;
    this.roles = {
      abonne_print: false, 
      abonne_news: false, 
      abonne_news_or_print: false, 
      abonne_nt: false,
      abonne_ntj: false,
      abonne_nts: false,
      abonne_pel: false,
      abonne_nf: false,
      abonne_fam: false,
      abonne_enf: false,
      abonne_num: false
    };
    this.bookmarks = [];
    this.likedcomments = [];
  }

  async getcurrentuser( backcheck ){
    if( typeof backcheck == 'undefined' ) backcheck = false;
    return new Promise((resolve, reject) => {
      // no backcheck
      if( !backcheck ){
        resolve();
      }

      // no token
      if( !( /^(.*;)?\s*kc_token\s*=\s*[^;]/.test(document.cookie) ) ){
        this.userinfos = this.defaultuserinfos;
        resolve();
      }

      return fetch( '/compte/status', {
        cache: "no-store"
      }).then( (response) => {
        return response.json();
      }).then( (responseuser) => {
        this.userinfos = responseuser.userinfos;
        this.roles = responseuser.roles;
        this.bookmarks = responseuser.bookmarks;
        this.likedcomments = responseuser.likedcomments;
        resolve();
      }).catch( (error) => {
        reject( error );
      });
    });
  }

  async appenduserinfostodatalayer( userinfos, roles ) {
    console.log( 'User : appenduserinfostodatalayer  - ', userinfos, roles );
    window.dataLayer = window.dataLayer || [];
    let userdatadas = {
      'loggedin': userinfos.loggedin,
      'email_sha256': userinfos.email_sha256,
      'type': userinfos.type,
      'keycloak_id' : userinfos.keycloak_id,
      'name' : userinfos.given_name,
      'abo_date_start' : userinfos.abo_date_start,
      'abo_date_end' : userinfos.abo_date_end
    };

    for ( const [roleid, rolevalue] of Object.entries(roles)) {
      userdatadas[roleid] = rolevalue;
    }


    if( window.dataLayer[0] ){
      window.dataLayer[0] = Object.assign(window.dataLayer[0], {'user': userdatadas});
    }
    window.dataLayer.push({'event':'userinfo','user': userdatadas});
  }

  async updateheaderstatus( userinfos ,roles) {
    console.log( 'User : updateheaderstatus - ', userinfos );
    if( userinfos.loggedin ){
      // update login in header
      [... document.querySelectorAll('#middleheader .autofill-header-login, #middleheader .autofill-header-login-burger')].map( i => i.innerHTML = userinfos.htmlloggin );
      [... document.querySelectorAll('.headeraccount .autofill-header-login, .headeraccount .autofill-header-login-burger')].map( i => i.innerHTML = userinfos.htmllogginaccount );
      // add account menu
      [... document.querySelectorAll('.menu-link-sub')].map( i => i.href = userinfos.url_espace_pro );

      if(roles.abonne_num || roles.abonne_print){
        [... document.querySelectorAll('a[data-kiosque]')].map(i => {
          i.closest('.markettingbloc').classList.add('bloc-kiosque');
          i.classList.add('link-kiosque');
          i.closest('.markettingbloc').classList.remove('markettingbloc');
          i.href = i.dataset.kiosque;
          if(i.closest('#middleheader'))
          {
            i.dataset.bloctypekiosque = 'header';
            i.querySelector('span').innerText = 'Lire mon magazine';
          }
          else{
            i.dataset.bloctypekiosque = 'menuburger';
            i.text = 'Lire mon magazine';
          }
          
        });
      }



      if( document.getElementById('content-accountmenu') ){
        document.getElementById('content-accountmenu').innerHTML = userinfos.htmlmenu;
        if( document.getElementById('accountmenulink') ){
          document.getElementById('accountmenulink').addEventListener('click', (e)=>{
            [... document.querySelectorAll('.overlay-accountmenu')].map( i => i.classList.add( 'open' ) );

            [... document.querySelectorAll('.close-accountmenu, .overlay-accountmenu')].map( closelink => {
              closelink.addEventListener('click', (e)=>{
                [... document.querySelectorAll('.overlay-accountmenu')].map( i => i.classList.remove( 'open' ) );
              });
            });
          });
        }
      }
    } else {
      [... document.querySelectorAll('#middleheader .autofill-header-login, #middleheader .autofill-header-login-burger')].map( i => i.innerHTML = userinfos.htmlloggin );
      [... document.querySelectorAll('.headeraccount .autofill-header-login, .headeraccount .autofill-header-login-burger')].map( i => i.innerHTML = userinfos.htmllogginaccount );
    }
  }

  async updateautofillinput( userinfos ){
    console.log( 'User : updateautofillinput - ', userinfos );
    if( userinfos.loggedin ){
      [... document.querySelectorAll('.autofill-text-login-name')].map( i => i.innerHTML = userinfos.name );
      [... document.querySelectorAll('.autofill-text-login-email')].map( i => i.innerHTML = userinfos.email );
      [... document.querySelectorAll('.autofill-input-login-name')].map( i => i.value = userinfos.name );
      [... document.querySelectorAll('.autofill-input-login-email')].map( i => i.value = userinfos.email );
    } else {
      [... document.querySelectorAll('.autofill-text-login-name, .autofill-text-login-email')].map( i => i.innerHTML = '' );
      [... document.querySelectorAll('.autofill-input-login-name, .autofill-input-login-email')].map( i => i.value = '' );
    }
  }

  async updatecommentstatus( userinfos, likedcomments ) {
    console.log( 'User : updatecommentstatus - ', userinfos, likedcomments );
    if( document.getElementById('sidebarcomments') ){
      if( userinfos.loggedin ){
          [... document.querySelectorAll('#sidebarcomments .logged')].map( elt => {
            elt.classList.remove('logged');
          });
          [... document.querySelectorAll('#sidebarcomments .notlogged')].map( elt => {
            elt.style.display = 'none';
          });
      } else {
        [... document.querySelectorAll('#sidebarcomments .logged')].map( elt => {
          elt.classList.add('logged');
        });
        [... document.querySelectorAll('#sidebarcomments .notlogged')].map( elt => {
          elt.style.display = 'block';
        });
      }

    }
  }

  async addlogoutaction( userinfos ) {
    console.log( 'User : addlogoutaction - ', userinfos );
    let user = this;
    [... document.querySelectorAll('.logout')].map( logoutlink => {
      logoutlink.addEventListener('click', (e)=> {
        user.disconnectuserandtriggerevents();
      });
    });
  }

  async updatecontentbookmark( userinfos, userbookmarks ){
    if( userinfos.loggedin ){
      let contentid = document.querySelector('body').dataset.id;
      if( userbookmarks.includes( parseInt( contentid ) ) ){
        let linkbookmark = document.querySelector('.link-bookmark');
        linkbookmark.dataset.bookmark = 1;
        linkbookmark.innerHTML = 'Retirer de votre sélection';
      }
    }
  }

  async onUserLoad( callback ){
    if (typeof callback === 'function'){
      if( this.loaded ){
        console.log( 'User : run onUserLoad - ' + callback.name );
        callback( { detail: { userinfos: this.userinfos, roles: this.roles, bookmarks: this.bookmarks, likedcomments: this.likedcomments } } );
      } else {
        console.log( 'User : append listener onUserLoad - ' + callback.name );
        addEventListener( "userload", callback, false );
      }
    }
  }

  async onUserDisconnect( callback ){
    if (typeof callback === 'function'){
      console.log( 'User : append listener onUserDisconnect - ' + callback.name);
      addEventListener( "userdisconnect", callback, false );
    }
  }

  async loaduserandtriggerevents( backcheck ){
    console.log( 'User : loaduserandtriggerevents' );
    let user = this;
    if( typeof backcheck == 'undefined' ) backcheck = false;
    user.getcurrentuser(backcheck).then( () => {
      user.loaded = true;
      const userloadevent = new CustomEvent( "userload", { detail: { userinfos: user.userinfos, roles: user.roles, bookmarks: user.bookmarks, likedcomments: user.likedcomments } });
      dispatchEvent(userloadevent);
      if( user.userinfos.loggedin ){
        user.lauchKcRefreshWithInterval();
      }
    }).catch( (error) => {
      console.log( 'User : loaduserandtriggerevents - ', error );
      user.loaded = true;
      const userloadevent = new CustomEvent( "userload", { detail: { userinfos: user.userinfos, roles: user.roles, bookmarks: user.bookmarks, likedcomments: user.likedcomments } });
      dispatchEvent(userloadevent);
    });
  }

  async removecookies(){
    return new Promise((resolve) => {
      if( Cookies.get('kc_token') ){
        Cookies.remove( 'kc_token', { domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' } );
      }
      if( localStorage.getItem('kc_idtoken') ){
        localStorage.removeItem( 'kc_idtoken');
      }
      if( localStorage.getItem('kc_refreshtoken') ){
        localStorage.removeItem( 'kc_refreshtoken');
      }
      resolve();
    });
  }

  async disconnectuserandtriggerevents(){
    console.log( 'User : disconnectuserandtriggerevents' );
    let user = this;
    // first remove KcRefreshWithInterval
    user.removeKcRefreshWithInterval();
    // then remove cookies and run userdisconnect
    user.removecookies().then( function(){
      user.userinfos = user.defaultuserinfos;
      const userdisconnectevent = new CustomEvent( "userdisconnect", { detail: { userinfos: user.userinfos, roles: user.roles, bookmarks: user.bookmarks, likedcomments: user.likedcomments } });
      dispatchEvent(userdisconnectevent);
    });
  }

  // refresh keycloak token
  async lauchKcRefresh(){
    console.log( 'User lauchKcRefresh' );
    let user = this;
    if( user.keycloak ){
      user.keycloak.updateToken(90).success( function(refreshed){
        if( refreshed ) {
          console.log( 'User : lauchKcRefresh - refreshed is done' );
          Cookies.set('kc_token', user.keycloak.token, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
          localStorage.setItem('kc_idtoken', user.keycloak.idToken, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
          localStorage.setItem('kc_refreshtoken', user.keycloak.refreshToken, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
        }
      }).error(function( error ){
        //if init error, we remove cookies and return to anonymous
        console.log( 'User : lauchKcRefresh - updateToken error', error );
        user.disconnectuserandtriggerevents();
      });
    } else {
      //if init error, we remove cookies and return to anonymous
      console.log( 'User : lauchKcRefresh - no keycloak' );
      user.disconnectuserandtriggerevents();
    }
  }

  /* auto refresh token if it's valid for less then 90s (every minutes) */
  async lauchKcRefreshWithInterval(){
    console.log( 'User lauchKcRefreshWithInterval' );
    let user = this;
    if( !user.tokenrefreshinterval ) {
      user.tokenrefreshinterval = setInterval( function(){
        console.log( 'User lauchKcRefreshWithInterval - interval' );
        user.lauchKcRefresh();
      }, 5000 );
    }
    console.log( 'User lauchKcRefreshWithInterval - direct' );
    user.lauchKcRefresh();
  }

  /* remove auto refresh token if it's valid for less then 90s (every minutes) */
  async removeKcRefreshWithInterval(){
    console.log( 'User removeKcRefreshWithInterval' );
    if( this.tokenrefreshinterval ) {
      clearInterval( this.tokenrefreshinterval );
      this.tokenrefreshinterval = null;
    }
  }

  async init(){
    console.log( 'User : init');
    let user = this;

    this.onUserLoad( (e) => {
      console.log( e.detail );
      this.updateheaderstatus( e.detail.userinfos ,e.detail.roles);
      this.updateautofillinput( e.detail.userinfos );
      this.addlogoutaction( e.detail.userinfos );
      this.updatecommentstatus( e.detail.userinfos, e.detail.likedcomments );
      this.updatecontentbookmark( e.detail.userinfos, e.detail.bookmarks );
      this.appenduserinfostodatalayer( e.detail.userinfos, e.detail.roles );
    });

    this.onUserDisconnect( (e) => {
      this.updateheaderstatus( e.detail.userinfos,e.detail.roles );
      this.updateautofillinput( e.detail.userinfos );
      this.updatecommentstatus( e.detail.userinfos, e.detail.likedcomments );
      this.updatecontentbookmark( e.detail.userinfos,e.detail.bookmarks );
    });

    /* catch these events only if Keycloak is loaded */
    if( typeof Keycloak !== 'undefined' ){
      console.log( 'User : Keycloak init');
      user.keycloak =  Keycloak( '/keycloak.json' );

      let initParams = {
        timeSkew: 0
      };

      // si page de recherche ou page inscription on ne check pas la connexion
      // evite le reload de page sur les pages avec des données postées
      let regexSearch = new RegExp('/recherche*');

      if( Cookies.get('kc_token') ) {
        if( localStorage.getItem('kc_idtoken') && localStorage.getItem('kc_refreshtoken') )
        {
          console.log( 'User : Keycloak Init Keycloak with token params' );
          // local storage is used for exact domain match
          initParams.token = Cookies.get('kc_token');
          initParams.idToken = localStorage.getItem('kc_idtoken');
          initParams.refreshToken = localStorage.getItem('kc_refreshtoken');
        } else {
          // if cookie exists and local storage not, you changed from subdomain
          console.log( 'User : Keycloak Init with check-sso enabled');
          initParams.token = Cookies.get('kc_token');
          initParams.onLoad = 'check-sso';
        }
      } else if(!regexSearch.test(window.location.pathname)  && document.querySelectorAll('#main form').length == 0) {
        // if cookie not exists
        initParams.onLoad = 'check-sso';
      }


      user.keycloak.init( initParams ).success( function( authenticated ) {
        if( authenticated ) {
          console.log( 'User : Keycloak user is authenticated' );
          // define cookies ( for JS + server side token use )
          Cookies.set('kc_token', user.keycloak.token, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
          // and localStorage ( for JS use )
          localStorage.setItem('kc_idtoken', user.keycloak.idToken, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
          localStorage.setItem('kc_refreshtoken', user.keycloak.refreshToken, { expires:1, domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' });
          if( window.location.pathname == '/compte/loginsuccess' )
          {
            window.location.reload();
          } else {
            user.loaduserandtriggerevents( true );
          }
        }
        else
        {
          //if init return false on authenticated, we remove cookies and return to anonymous
          console.log( 'User : Keycloak user is not authenticated' );
          user.removecookies();
          if( window.location.pathname == '/compte/loginsuccess' )
          {
            window.location.href = '/compte/connexion';
          } else {
            user.loaduserandtriggerevents();
          }
        }
      }).error(function(){
        //if init error, we remove cookies and return to anonymous
        console.log( 'User : Keycloak init error' );
        user.removecookies();
        user.loaduserandtriggerevents();
      });


      document.addEventListener( 'click', function (e) {
        let link = event.target;
        let found = false;

        while (link && !( found = link.classList.contains( 'login-link' ) ) ) {
          link = link.parentElement;
        }

        if (found) {
          e.preventDefault();
          let redirectUri = window.location.href;
          if( link.dataset.target ){
            redirectUri = link.dataset.target;
          }

          if(redirectUri.indexOf('#comments') > 0){
            redirectUri = redirectUri.replace("#comments","");
          }

          let ga = Cookies.get('_ga');
          if( ga ){
            let gaValue = ga.replace('GA1.2.','');
            if(redirectUri.indexOf("?") > 0) {
              redirectUri+="&ga_cid="+gaValue;
            }
            else {
              redirectUri+="?ga_cid="+gaValue;
            }
            let time = Math.round(Date.now() / 1000);
            redirectUri+="&ga_time="+time;
          }

          if( link.parentElement.dataset.origin  ){
            redirectUri+= ((redirectUri.indexOf("?") > 0) ? "&" : "?")+"origin_campaign="+link.parentElement.dataset.origin;
          }

          if( link.dataset.anchor ){
            redirectUri += '#' + link.dataset.anchor;
          }

          if(window.location.href.indexOf("#comments") > 0){
            redirectUri+="#comments";
          }

          user.keycloak.login({ scope:'address',redirectUri: redirectUri });
        }
      });
    } else {
      console.log( 'User : Keycloak doesn\'t exists');
      user.loaduserandtriggerevents();
    }
  }
}

const currentuser = new User();
export default currentuser;
